<template>
  <div class="blog-post-page container">
    <div class="post" v-if="post != null">
      <img :src="image" :alt="post.title" />
      <h3>
        {{ post.title }}
      </h3>
      <p class="date">posted on {{ date }}</p>
      <p v-html="post.body"></p>
    </div>
    <template v-else>
      <div v-if="!loading" class="post" style="text-align:center">
        <h1>404</h1>
        <h3>Article not found</h3>
      </div>
      <div v-else class="load-spinner" style="margin:auto;"></div>
    </template>
    <!-- TODO - Comments -->
    <div class="comments" v-if="post != null">
      <div class="heading">
        <h3>Comments ({{ comments.length }})</h3>
      </div>

      <div class="form" v-if="post.comments_enabled">
        <!-- TODO - form design -->
        <form action="">
          <div></div>
          <div></div>
          <div></div>
        </form>
      </div>
      <div v-else>
        <p>Comments are disabled / stopped</p>
      </div>

      <div class="body" v-if="comments.length">
        <comment
          v-for="comment in comments"
          :comment="comment"
          :key="comment.id"
        ></comment>
      </div>
      <div v-else>
        <p>No comments</p>
      </div>
    </div>
  </div>
</template>

<script>
import comment from "@/components/BlogPostComment";
import axios from "axios";
import moment from "moment";

export default {
  name: "BlogPost",
  components: {
    comment
  },
  data() {
    return {
      post: null,
      comments: [],
      loading: true
    };
  },
  computed: {
    image() {
      return this.post.image || "/dashboard-assets/img/album/img-1.jpg";
    },
    date() {
      return moment(this.post.created_at).fromNow();
    }
  },

  methods: {
    loadPost(slug) {
      axios
        .get("/blog/" + slug)
        .then(response => {
          this.post = response.data.post;
          this.comments = response.data.post.comments;
        })
        .catch(error => {
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  beforeRouteUpdate(to, from, next) {
    const slug = to.params.slug;
    this.loadPost(slug);
    next();
  },

  mounted() {
    const slug = this.$route.params.slug;
    this.loadPost(slug);
  }
};
</script>
